import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formPolicyPacket_formContainer: {
			display: 'flex',
			flexDirection: 'column',
			margin: 'auto',
		},
		formPolicyPacket_bodyHeader: {
			textAlign: 'center',
			width: '100%',
			'& > h1': {
				fontWeight: 400,
				fontSize: '2.5rem',
				lineHeight: '2.5rem',
				textAlign: 'center',
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					textAlign: 'left'
				},
			},
			'& > h3': {
				fontWeight: 300,
				fontSize: '1.75rem',
				lineHeight: '2.5rem',
				textAlign: 'center',
				[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
					textAlign: 'left'
				},
			}
		},
		formPolicyPacket_headerMessage: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h6.fontSize,
			padding: theme.spacing(1.5, 1.5),
			lineHeight: theme.spacing(3.5)
		},
		formPolicyPacket_inputContainer: {
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
		},
		formPolicyPacket_inputWrapper: {
			padding: theme.spacing(3, 0),
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				flex: '1 0',
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				width: '600px',
			},

		},
	});
});

export default useStyles;
